export function LockIcon({ size = 36 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      shapeRendering="crispEdges"
      aria-hidden="true"
      role="presentation"
      style={{ color: "var(--color-green-bright)" }}
    >
      {/* Shackle */}
      <rect x="5" y="2" width="6" height="1" fill="currentColor" />
      <rect x="4" y="3" width="1" height="1" fill="currentColor" />
      <rect x="11" y="3" width="1" height="1" fill="currentColor" />
      <rect x="4" y="4" width="1" height="3" fill="currentColor" />
      <rect x="11" y="4" width="1" height="3" fill="currentColor" />
      {/* Body */}
      <rect x="3" y="7" width="10" height="7" fill="currentColor" />
      {/* Keyhole */}
      <rect x="7" y="9" width="2" height="2" fill="#000" />
      <rect x="7" y="11" width="2" height="2" fill="#000" />
    </svg>
  );
}
